import qz from 'qz-tray'
import RSVP from 'rsvp'
import shajs from 'sha.js'
import { createClient as createSignClient } from '../api/signClient'
import { getCert } from './cert'
import { ErrorForTranslation } from '../ErrorForTranslation'

const signClient = createSignClient()

const QZ_CONNECTION_TIMEOUT_MS = 5000

let lastConnectionError = null

const setQzTrayConfig = () => {
	qz.api.setPromiseType(resolver => {
		return new RSVP.Promise(resolver)
	})

	qz.api.setSha256Type(data => {
		return shajs('sha256')
			.update(data)
			.digest('hex')
	})

	qz.security.setCertificatePromise(resolve => {
		resolve(getCert())
	})

	qz.security.setSignaturePromise(toSign => {
		return function(resolve, reject) {
			return signFromServer(
				toSign,
				function(response) {
					resolve(response.signature)
				},
				reject
			)
		}
	})
}

const signFromServer = (reqToSign, successCallback, errorCallback) => {
	return signClient
		.post('/api/v0/sign', { request: reqToSign })
		.then(response => {
			successCallback(response.data)
		})
		.catch(err => {
			errorCallback(err)
		})
}

const connectQzTray = () => {
	return new Promise((resolve, reject) => {
		setQzTrayConfig()

		if (qz.websocket.isActive()) {
			resolve()
		}

		setTimeout(() => {
			if (!qz.websocket.isActive()) {
				qz.websocket.disconnect()
				reject(new ErrorForTranslation('stationSetup.ERROR_QZ_TRAY'))
			}
		}, QZ_CONNECTION_TIMEOUT_MS)

		qz.websocket
			.connect({ retries: 1, delay: 0 })
			.then(() => {
				lastConnectionError = null
				resolve()
			})
			.catch(err => {
				lastConnectionError = err
				reject(new ErrorForTranslation('stationSetup.ERROR_QZ_TRAY', err))
			})
	})
}

const getVersion = () => {
	return connectQzTray()
		.then(() => {
			return qz.api.getVersion()
		})
		.catch(err => {
			throw new Error(err)
		})
}

const getAllPrinters = () => {
	return connectQzTray().then(() => {
		return qz.printers
			.find()
			.then(function(printerNames) {
				if (!printerNames || printerNames.length === 0) {
					throw new ErrorForTranslation(
						'stationSetup.ERROR_NO_PRINTER_NAME_FOUND'
					)
				}

				return printerNames
			})
			.catch(function(err) {
				throw new ErrorForTranslation(
					'stationSetup.ERROR_INVALID_CONFIGURATION',
					err
				)
			})
	})
}

const getSpecificPrinter = printerName => {
	return connectQzTray().then(() => {
		return qz.printers.find(printerName).catch(function(err) {
			throw new ErrorForTranslation('stationSetup.ERROR_FIND_QZ', err, {
				printer: printerName
			})
		})
	})
}

const print = (data, printer) => {
	return new Promise((resolve, reject) => {
		connectQzTray()
			.then(() => qz.configs.create(printer, { encoding: 'utf-8' }))
			.then(cfg => qz.print(cfg, data))
			.then(() => resolve())
			.catch(err => reject(err))
	})
}

const getConnectionStatus = () => {
	if (qz.websocket.isActive()) {
		return 'OK'
	} else {
		return lastConnectionError
	}
}

export {
	connectQzTray,
	getVersion,
	getAllPrinters,
	getSpecificPrinter,
	print,
	getConnectionStatus
}



// WEBPACK FOOTER //
// ./src/common/qz/qzTrayService.js